import { render, staticRenderFns } from "./plan-suggestion-form.vue?vue&type=template&id=7bcd5064"
import script from "./plan-suggestion-form.js?vue&type=script&lang=js&external"
export * from "./plan-suggestion-form.js?vue&type=script&lang=js&external"
import style0 from "./plan-suggestion-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports